import { Component, Inject, OnInit } from '@angular/core';
import { CompanyWorker, CountriesService, SalesDocumentClient } from '@icc/b2b/shared';
import { DialogRef, DIALOG_DATA } from '@icc/ui';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'icc-client-preview-dialog',
  templateUrl: './client-preview-dialog.component.html',
  styleUrls: ['./client-preview-dialog.component.scss']
})
export class ClientPreviewDialogComponent implements OnInit {

    private subscriptions: Subscription[] = [];


    constructor(
        private dialogRef: DialogRef,
        @Inject(DIALOG_DATA)
        public data: {
            client: SalesDocumentClient;
            isSeller: boolean;
        },
        private translateService: TranslateService,
        private countriesService: CountriesService
    ) {}

    ngOnInit(): void {
    }

    getRegion(countryId: string, regionId: number) {
        return this.countriesService.getRegions(countryId).find(region => Number(region.id) === Number(regionId));
    }

    getRegionName(countryId: string, regionId: number) {
        const region = this.getRegion(countryId, regionId);
        if(region){
            return region.name;
        }
        return '';
    }

    getCountry(countryId: string) {
        return this.countriesService.getCountry(countryId);
    }

    close() {
        this.dialogRef.close();
    }

}
